<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row px-10 mb-4>
            <v-flex md12 pa-10>
                <h1 class="layout__width-700px layout__margin-0-auto text-center pb-4 text__colour-teal">Thank you for placing your order with Ravensworth</h1>

                <div class="text-center pt-5 text__line-height-12">
                    <div>Order reference: {{orderId}}</div>
                </div>

                <div class="text-center pt-5 text__line-height-12">
                    Direct Mail delivery can be expected up to 5 working days.
                </div>

                <div class="text-center pt-5 text__line-height-12">
                    <div>You can view your orders by clicking the button below.</div>
                </div>

                <div>
                    <v-row class="align-center justify-center layout__margin__top-50 layout__margin__bottom-0">
                        <a v-bind:href="this.customerHubUrl" target="_parent">
                            <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-left">
                                    View my orders
                            </el-button>
                        </a>
                    </v-row>
                </div>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js'
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingConfirmation',
        components: {
        },
        mixins: [axios],
        data: () => ({
            orderId: null,
            customerHubUrl: '',
            customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
        }),
        watch: {
        },
        async created () {
            this.orderId = window.sessionStorage.getItem('_order_id');
            console.log(this.orderId);

            //Clear session variables
            window.sessionStorage.removeItem('_currentPlace');
            window.sessionStorage.removeItem('_circles');
            window.sessionStorage.removeItem('_currentPlace2020');
            window.sessionStorage.removeItem('_location');
            window.sessionStorage.removeItem('_radius');
            window.sessionStorage.removeItem('_radius_value');
            window.sessionStorage.removeItem('_radius_value_location');
            window.sessionStorage.removeItem('_radius_value_radius');
            window.sessionStorage.removeItem('_radius_units_location');
            window.sessionStorage.removeItem('_radius_units_radius');
            window.sessionStorage.removeItem('_templateType');
            window.sessionStorage.removeItem('_readAndAgreedChecked');
            window.sessionStorage.removeItem('_previewConfirmed');
            window.sessionStorage.removeItem('_order_id');
            window.sessionStorage.removeItem('_connection_params');
            window.sessionStorage.removeItem('_myPreferences');
            window.sessionStorage.removeItem('_imPreference');
            window.sessionStorage.removeItem('_template');
            window.sessionStorage.removeItem('_fulfilment_type');
            window.sessionStorage.removeItem('_databook_auth_token');
            window.sessionStorage.removeItem('_leadhub_auth_token');
            window.sessionStorage.removeItem('_canvas_auth_token');
            window.sessionStorage.removeItem('_addressTo');
            window.sessionStorage.removeItem('_personalData');
            window.sessionStorage.removeItem('_seedData');
            window.sessionStorage.removeItem('_mockupFile');
            window.sessionStorage.removeItem('_priceCodes');
            window.sessionStorage.removeItem('stateId');
            window.sessionStorage.removeItem('customer');
            window.sessionStorage.removeItem('user');
            window.sessionStorage.removeItem('templatingValues');

            parent.postMessage('ClearDMOrder', '*');

            //this.customerHubUrl = `${process.env.VUE_APP_CUSTOMERHUBUIHOST}/orders/photofixr/?transferToken=` + authCookies["_token"]
            this.customerHubUrl = `${process.env.VUE_APP_CUSTOMERHUBUIHOST}/orders/directmailr/?transferToken=` + window.sessionStorage.getItem('_auth_token');

            console.log('customer hub url ' + this.customerHubUrl)
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path
                });
            },
        }
    };
</script>
